import $http from '@Config/axios';
import $store from '@Store';

const prefix = 'formulario';
const tipo = 'Formulário';
const artigo = 'o';

export default {
  index(params) {
    return new Promise((resolve, reject) => {
      $http.post(`${prefix}/index`, params)
        .then(response => resolve(response))
        .catch(response => reject(response));
    });
  },
  indexPaginate(params) {
    return new Promise((resolve, reject) => {
      $http.post(`${prefix}/indexPaginate`, params)
        .then(response => resolve(response))
        .catch(response => reject(response));
    });
  },
  show(id) {
    return new Promise((resolve, reject) => {
      $http.get(`${prefix}/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(response => reject(response));
    });
  },
  store(params) {
    return new Promise((resolve, reject) => {
      $http.post(prefix, params)
        .then(response => {
          // $store.dispatch('SHOW_SNACKBAR', { message: `${tipo} enviad${artigo} com sucesso!` });
          resolve(response);
        })
        .catch(response => reject(response));
    });
  },
  update(params) {
    return new Promise((resolve, reject) => {
      $http.put(`${prefix}/${params.id}`, params)
        .then(response => {
          // $store.dispatch('SHOW_SNACKBAR', { message: `${tipo} atualizad${artigo} com sucesso!` });
          resolve(response);
        })
        .catch(response => reject(response));
    });
  },
  destroy(id) {
    return new Promise((resolve, reject) => {
      $http.delete(`${prefix}/${id}`)
        .then(response => {
          $store.dispatch('SHOW_SNACKBAR', { message: `${tipo} excluíd${artigo} com sucesso!` });
          resolve(response);
        })
        .catch(response => reject(response));
    });
  },
  restore(id) {
    return new Promise((resolve, reject) => {
      $http.patch(`${prefix}/${id}`)
        .then(response => {
          // $store.dispatch('SHOW_SNACKBAR', { message: `${tipo} restaurad${artigo} com sucesso!` });
          resolve(response);
        })
        .catch(response => reject(response));
    });
  },
  visualize(params) {
    return new Promise((resolve, reject) => {
      $http.put(`${prefix}/visualize/${params.id}`, params)
        .then(response => {
          resolve(response);
        })
        .catch(response => reject(response));
    });
  },
  uploadImage(params) {
    return new Promise((resolve, reject) => {
      $http.post(`${prefix}/uploadImage`, params)
        .then(response => {
          resolve(response);
        })
        .catch(response => reject(response));
    });
  },
  buscarNotas(params) {
    return new Promise((resolve, reject) => {
      $http.post(`${prefix}/buscarNotas`, params)
        .then(response => resolve(response))
        .catch(response => reject(response));
    });
  },
  destroyFoto(id) {
    return new Promise((resolve, reject) => {
      $http.delete(`${prefix}/destroyFoto/${id}`)
        .then(response => {
          // $store.dispatch('SHOW_SNACKBAR', { message: 'Imagem excluida com sucesso' });
          resolve(response);
        })
        .catch(response => reject(response));
    });
  }
};
